import { useL10n } from "@ews/react-localization-context";
import SettingsTextInput from "../../../Settings/SettingsComponents/SettingsTextInput/SettingsTextInput";
import { TooltipIcon } from "../../../ToolTip/useTooltip";
import { useModifySystemSpecification, useSystemSpecification } from "../../../ReactData/system";

const ConstructionCompany: React.FC<{ systemId: string; }> = ({ systemId }) =>
{
    const { translate: t } = useL10n();
    const specification = useSystemSpecification(systemId);
    const modifySystemSpecification = useModifySystemSpecification();

    return <>

        <SettingsTextInput
            text={"PLG_USER_PROFILE_LST_FIELD_SALUTATION_COMPANY"}
            tooltip={<TooltipIcon text={t("PLG_USER_PROFILE_LST_FIELD_SALUTATION_COMPANY")} />}
            inputType={"text"}
            value={specification.constructionCompany?.company}
            onBlur={({ value }) =>
            {
                if (specification.constructionCompany?.company === value) return;
                if (systemId && specification.constructionCompany) {

                    const { address, telephoneNumber, email, contactPerson } = specification.constructionCompany;
                    modifySystemSpecification(systemId, {
                        ...specification,
                        constructionCompany: {
                            company: value,
                            address,
                            telephoneNumber,
                            email,
                            contactPerson
                        },
                    });
                }
            }
            } />
        <SettingsTextInput
            text={"TRVB_ADDRESS_LABEL"}
            tooltip={<TooltipIcon text={t("TRVB_ADDRESS_DESC")} />}
            inputType={"text"}
            value={specification.constructionCompany?.address}
            onBlur={({ value }) =>
            {
                if (specification.constructionCompany?.address === value) return;
                if (systemId && specification.constructionCompany) {
                    const { company, telephoneNumber, email, contactPerson } = specification.constructionCompany;
                    modifySystemSpecification(systemId, {
                        ...specification,
                        constructionCompany: {
                            address: value,
                            company,
                            telephoneNumber,
                            email,
                            contactPerson
                        },
                    });
                }
            }
            } />
        <SettingsTextInput
            text={"TRVB_CLERK_LABEL"}
            tooltip={<TooltipIcon text={t("TRVB_CLERK_LABEL")} />}
            inputType={"text"}
            value={specification.constructionCompany?.contactPerson}
            onBlur={({ value }) =>
            {
                if (specification.constructionCompany?.contactPerson === value) return;
                if (systemId && specification.constructionCompany) {
                    const { company, telephoneNumber, email } = specification.constructionCompany;
                    modifySystemSpecification(systemId, {
                        ...specification,
                        constructionCompany: {
                            contactPerson: value,
                            company,
                            telephoneNumber,
                            email
                        },
                    });
                }
            }
            } />
        <SettingsTextInput
            text={"TRVB_TEL_LABEL"}
            tooltip={<TooltipIcon text={t("TRVB_TEL_LABEL")} />}
            inputType={"tel"}
            value={specification.constructionCompany?.telephoneNumber}
            onBlur={({ value }) =>
            {
                if (specification.constructionCompany?.telephoneNumber === value) return;
                if (systemId && specification.constructionCompany) {
                    const { address, email, company, contactPerson } = specification.constructionCompany;
                    modifySystemSpecification(systemId, {
                        ...specification,
                        constructionCompany: {
                            telephoneNumber: value,
                            address,
                            company,
                            email,
                            contactPerson
                        },
                    });
                }
            }
            } />

        <SettingsTextInput
            text={"TRVB_MAIL_LABEL"}
            tooltip={<TooltipIcon text={t("TRVB_MAIL_LABEL")} />}
            inputType={"email"}
            value={specification.constructionCompany?.email}
            onBlur={({ value }) =>
            {
                if (specification.constructionCompany?.email === value) return;
                if (systemId && specification.constructionCompany) {
                    const { address, telephoneNumber, company, contactPerson } = specification.constructionCompany;
                    modifySystemSpecification(systemId, {
                        ...specification,
                        constructionCompany: {
                            email: value,
                            address,
                            telephoneNumber,
                            company,
                            contactPerson
                        },
                    });
                }
            }
            } />
    </>;
};

export default ConstructionCompany;
